module.exports = __webpack_public_path__ + "img/load2.bb051449.jpg";